import { create } from 'zustand';
import { OnChangeFn, RowSelectionState, Table, VisibilityState } from '@tanstack/react-table';

type RowSelection = RowSelectionState;
interface datatableStates {
  table: Table<any> | null;
  rowSelection: RowSelection;
  multipleRowSelections: any[];
  columnVisibility: VisibilityState;
  refetchTrigger: boolean;
  isApiLoading: boolean;

  // state setters
  setTables: (data: Table<any>) => void;
  setRowSelectionTable: (value: any) => void;
  setColumnVisibility: OnChangeFn<VisibilityState>;
  setRefetchTrigger: (value: boolean) => void;
  setIsApiLoading: (value: boolean) => void;
}

export const useDatatable = create<datatableStates>((set, get) => ({
  // initial state
  table: null,
  multipleRowSelections: [],
  rowSelection: {},
  columnVisibility: {},
  refetchTrigger: false,
  isApiLoading: false,

  // setters
  setTables: (data) => set({ table: data }),
  setRowSelectionTable: (rowSelection) => {
    const selections = Object.keys(rowSelection);

    const rowsData: any[] = [];

    selections.forEach((rowId) => {
      const rowData = get().table?.getRow(rowId);
      rowsData.push(rowData);
    });

    set({
      multipleRowSelections: rowsData || [],
    });

    set({ rowSelection });
  },
  setColumnVisibility: (updaterOrValue) =>
    set((state) => {
      const newUnvisible =
        typeof updaterOrValue === 'function'
          ? updaterOrValue(state.columnVisibility)
          : updaterOrValue;

      return { columnVisibility: newUnvisible };
    }),

  setRefetchTrigger: (value: boolean) => set({ refetchTrigger: value }),
  setIsApiLoading: (value: boolean) => set({ isApiLoading: value }),
}));
